// import { Link } from "react-router-dom";

// export default function Footer() {
//   return (
//     <footer className="mt-16 bg-brand.dark text-white">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-4">
//         <div>
//           <div className="flex items-center gap-2">
//             <div className="h-8 w-8 rounded bg-brand.sky" />
//             <span className="font-bold">Premier Carwash</span>
//           </div>
//           <p className="mt-3 text-white/70 text-sm">Worldwide car care excellence.</p>
//         </div>
//         <div>
//           <h4 className="font-semibold mb-3">Company</h4>
//           <ul className="space-y-2 text-white/80 text-sm">
//             <li><Link to="/services">Services</Link></li>
//             <li><Link to="/pricing">Pricing</Link></li>
//             <li><Link to="/contact">Contact</Link></li>
//           </ul>
//         </div>
//         <div>
//           <h4 className="font-semibold mb-3">Contact</h4>
//           <p className="text-sm text-white/80">mainstreetcarwashrb@gmail.com<br/>+1 (530) 529-3002</p>
//         </div>
//       </div>
//       <div className="border-t border-white/10 py-4 text-center text-xs text-white/60">© {new Date().getFullYear()} Premier Carwash</div>
//     </footer>
//   );
// }

import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative bg-[#0b1220] text-slate-200">
      {/* top border accent */}
      <div className="h-[2px] w-full bg-cyan-500/60" />

      {/* content */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-10 md:grid-cols-4">
          {/* Brand / blurb */}
          <div>
            <div className="flex items-center gap-2">
             
                  <img
    src="/logo1.png"   // or /logo.svg if that’s your file
    alt="Main Street Car Wash logo"
    className="h-13 w-auto object-contain"
  />
               
            </div>

           
           
          </div>

          {/* Popular links */}
          <div>
            <h4 className="font-semibold text-white">Popular Links</h4>
            <ul className="mt-4 space-y-3 text-slate-300">
              <li><Link to="/services" className="hover:text-white">Our Service</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            </ul>
          </div>

          {/* Get in touch */}
          <div>
            <h4 className="font-semibold text-white">Get In Touch</h4>
            <ul className="mt-4 space-y-3 text-slate-300">
              <li className="flex items-start gap-3">
                <MapPinIcon className="mt-1 h-5 w-5 text-cyan-400" />
                <span>409 Main Street,<br/>Red Bluff, CA</span>
              </li>
              <li className="flex items-start gap-3">
                <PhoneIcon className="mt-1 h-5 w-5 text-cyan-400" />
                <a href="tel:15305293002" className="hover:text-white">530 529-3002</a>
              </li>
              <li className="flex items-start gap-3 break-all">
                <MailIcon className="mt-1 h-5 w-5 text-cyan-400" />
                <a
                  href="mailto:mainstreetcarwashrb@gmail.com"
                  className="hover:text-white"
                >
                  mainstreetcarwashrb@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours + badge */}
          <div>
            <h4 className="font-semibold text-white">Hours</h4>
            <div className="mt-4 space-y-2 text-slate-300">
              <div className="flex items-start gap-3">
                <ClockIcon className="mt-1 h-5 w-5 text-cyan-400" />
                <div>
                  <div className="font-semibold text-white">Open</div>
                  <div className="text-cyan-300 font-extrabold text-2xl leading-6">24/7</div>
                </div>
              </div>
              <div>Monday – Sunday</div>
              {/* <div>24 Hours a Day</div> */}
            </div>

           
          </div>
        </div>

        {/* divider */}
        <div className="mt-10 h-px w-full bg-white/10" />

        {/* copyright */}
        <div className="py-6 text-center text-sm text-slate-400">
          © {new Date().getFullYear()} Main Street Car Wash. All Rights Reserved
        </div>
      </div>

      {/* Floating call button */}
      <a
        href="tel:15305293002"
        aria-label="Call Main Street Car Wash"
        className="group fixed bottom-6 right-6 z-50 inline-flex h-16 w-16 items-center justify-center rounded-full border-4 border-white/80 bg-[#0a1220] shadow-xl transition hover:scale-105"
      >
        <PhoneIcon className="h-7 w-7 text-white transition group-hover:rotate-6" />
      </a>
    </footer>
  );
}

/* --- Tiny inline icons (no external library needed) --- */
function MapPinIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
function PhoneIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M6.6 10.8a12.9 12.9 0 0 0 6.6 6.6l2.2-2.2a1.5 1.5 0 0 1 1.6-.35l3.3 1.1a1.5 1.5 0 0 1 1 1.41V20a2 2 0 0 1-2.2 2A18 18 0 0 1 2 6.2 2 2 0 0 1 4 4h1.64a1.5 1.5 0 0 1 1.41 1l1.1 3.3c.2.53.06 1.13-.35 1.54L6.6 10.8z" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
function MailIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-11Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
function ClockIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 7v6l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
